export function below(p) {
  return [p[0], p[1] - 1.2, p[2]];
}
